var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuspendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.36 0 0 3.36 0 7.5C0 11.64 3.36 15 7.5 15C11.64 15 15 11.64 15 7.5C15 3.36 11.64 0 7.5 0ZM6 10.5C5.5875 10.5 5.25 10.1625 5.25 9.75V5.25C5.25 4.8375 5.5875 4.5 6 4.5C6.4125 4.5 6.75 4.8375 6.75 5.25V9.75C6.75 10.1625 6.4125 10.5 6 10.5ZM9 10.5C8.5875 10.5 8.25 10.1625 8.25 9.75V5.25C8.25 4.8375 8.5875 4.5 9 4.5C9.4125 4.5 9.75 4.8375 9.75 5.25V9.75C9.75 10.1625 9.4125 10.5 9 10.5Z",
    fill: "#F2994A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspendIcon);
export default __webpack_public_path__ + "static/media/suspendIcon.6f67ab850ee0f050003af527c15e3a8e.svg";
export { ForwardRef as ReactComponent };